import { IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import clampDiagram from '../../../../assets/images/information-images/clampDiagram.png';
import clampLeekExample from '../../../../assets/images/information-images/clampLeakExample.png';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface ClampPressureModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
}

export const ClampPressureModal: React.FC<ClampPressureModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.clampPressureHeading)}
      onClose={onClose}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.overviewHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.clampPressureOverviewDescriptionOne)}</DqText>
      </IonRow>
      <img src={clampDiagram} alt="clamp diagram" />

      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.clampPressureOverviewDescriptionTwo)}</DqText>
      </IonRow>
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.insightsHeading)}</DqText>
      </IonRow>
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.clampPressureInsightDescriptionOne)}</DqText>
        </li>
        <ul>
          <DqText variant="body">{formatMessage(JobMessages.clampPressureInsightDescriptionOneBullet)}</DqText>
        </ul>
      </ul>
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.clampPressureInsightDescriptionTwo)}</DqText>
        </li>
        <ul>
          <DqText variant="body">{formatMessage(JobMessages.clampPressureInsightDescriptionTwoBullet)}</DqText>
        </ul>
        <ul>
          <li>
            <DqText variant="body">{formatMessage(JobMessages.clampPressureInsightDescriptionThree)}</DqText>
          </li>
          <img src={clampLeekExample} alt="clamp diagram" />

          <ul>
            <DqText variant="body">{formatMessage(JobMessages.clampPressureInsightDescriptionThreeBullet)}</DqText>
          </ul>
        </ul>
      </ul>
    </AppModal>
  );
};

export default ClampPressureModal;
